/* prettier-ignore */

import { Component, computed, inject } from "@angular/core";
import { AddPdfComponent } from "../send-update-route/add-pdf/add-pdf.component";
import { SendRouteComponent } from "../send-update-route/send-route/send-route.component";
import { SendUpdateRouteService } from "../send-update-route/send-update-route.service";
import { AuthService } from "src/app/auth/services";
import { ToolsService } from "src/app/services/tools.service";
import { DebugService } from "src/app/services/debug.service";
import { ScrollBardModule } from "src/app/directives/scroll-bar/scroll-bar.module";

@Component({
  selector: "app-info-route",
  imports: [
    AddPdfComponent, 
    SendRouteComponent,
    ScrollBardModule
  ],
  standalone: true,
  templateUrl: "./info-route.component.html",
  styleUrls: ["./info-route.component.scss"],
})

export class InfoRouteComponent {
  private debugService = inject(DebugService);
  private _toolsService = inject(ToolsService);
  private sendUpdateService = inject(SendUpdateRouteService);
  public authService = inject(AuthService);
  public pdfsByCategories = computed(() => this.sendUpdateService.pdfsByCategories());

  ngOnInit(): void {
    this.authService.customLogOut();
    this.sendUpdateService.loadInitialData();
    this._toolsService.isInfoRoutePage.set(true);
    this.debugService.info(this.pdfsByCategories(), '[InfoRouteComponent] PDFs by categories');
  }
  
}
